import Vue from 'vue'

// 获取飞书配置
export function feishuConfig() {
  return Vue.axios({
    url: '/api/feishu/config',
    method: 'get'
  })
}

// 保存飞书配置
export function saveFeishuConfig(data) {
  return Vue.axios({
    url: '/api/feishu/saveConfig',
    method: 'post',
    data: { ...data }
  })
}

// 测试飞书连接
export function feishuTestConnection() {
  return Vue.axios({
    url: '/api/feishu/testConnection',
    method: 'post',
    data: {}
  })
}

// 创建多维表格
export function feishuCreateBitable(data) {
  return Vue.axios({
    url: '/api/feishu/bitable/create',
    method: 'post',
    data: { ...data }
  })
}

// 新增一个数据表（在已有多维表格 App 内新建数据表）
export function feishuCreateTable(data) {
  return Vue.axios({
    url: '/api/feishu/bitable/createTable',
    method: 'post',
    data: { ...data }
  })
}

// 删除多个数据表（在已有多维表格 App 内批量删除数据表）
export function feishuBatchDeleteTables(data) {
  return Vue.axios({
    url: '/api/feishu/bitable/batchDeleteTables',
    method: 'post',
    data: { ...data }
  })
}

// 删除多条记录（在已有多维表格数据表内批量删除记录）
export function feishuBatchDeleteRecords(data) {
  return Vue.axios({
    url: '/api/feishu/bitable/batchDeleteRecords',
    method: 'post',
    data: { ...data }
  })
}

// 列出数据表（获取已有多维表格 App 内的数据表列表）
export function feishuListTables(data) {
  return Vue.axios({
    url: '/api/feishu/bitable/listTables',
    method: 'get',
    params: { ...data }
  })
}

// 列出数据表字段（获取已有多维表格数据表内的字段列表）
export function feishuListFields(data) {
  return Vue.axios({
    url: '/api/feishu/bitable/listFields',
    method: 'get',
    params: { ...data }
  })
}

// 删除字段（删除已有多维表格数据表内的字段）
export function feishuDeleteField(data) {
  return Vue.axios({
    url: '/api/feishu/bitable/deleteField',
    method: 'delete',
    params: { ...data }
  })
}

// 新增字段（在已有多维表格数据表内新增字段）
export function feishuCreateField(data) {
  return Vue.axios({
    url: '/api/feishu/bitable/createField',
    method: 'post',
    data: { ...data }
  })
}

// 更新字段（更新已有多维表格数据表内的字段）
export function feishuUpdateField(data) {
  return Vue.axios({
    url: '/api/feishu/bitable/updateField',
    method: 'put',
    data: { ...data }
  })
}

// 更新数据表（修改已有多维表格 App 内数据表的名字）
export function feishuUpdateTable(data) {
  return Vue.axios({
    url: '/api/feishu/bitable/updateTable',
    method: 'patch',
    data: { ...data }
  })
}

// 新增多条记录
export function feishuBatchCreateRecords(data) {
  return Vue.axios({
    url: '/api/feishu/bitable/batchCreateRecords',
    method: 'post',
    data: { ...data }
  })
}

// 查询已创建的多维表格信息表（含其下数据表）
export function feishuBitableRecords(data) {
  return Vue.axios({
    url: '/api/feishu/bitable/records',
    method: 'get',
    params: { ...data }
  })
}

// 获取「月度总表 → 飞书」同步配置（含全局默认与可同步字段定义）
export function feishuSyncConfig(data) {
  return Vue.axios({
    url: '/api/feishu/syncConfig',
    method: 'get',
    params: { ...data }
  })
}

// 保存「月度总表 → 飞书」全局同步配置
export function saveFeishuSyncConfig(data) {
  return Vue.axios({
    url: '/api/feishu/syncConfig',
    method: 'post',
    data: { ...data }
  })
}

// 同步月度总表到飞书多维表格（可携带临时覆盖配置）
export function feishuSyncMonthly(data) {
  return Vue.axios({
    url: '/api/feishu/syncMonthly',
    method: 'post',
    data: { ...data }
  })
}

// 获取「销售维度 → 飞书」同步配置（含全局默认与可同步字段定义）
export function feishuSaleSyncConfig(data) {
  return Vue.axios({
    url: '/api/feishu/saleSyncConfig',
    method: 'get',
    params: { ...data }
  })
}

// 保存「销售维度 → 飞书」全局同步配置
export function saveFeishuSaleSyncConfig(data) {
  return Vue.axios({
    url: '/api/feishu/saleSyncConfig',
    method: 'post',
    data: { ...data }
  })
}

// 同步销售维度到飞书多维表格（可携带临时覆盖配置）
export function feishuSyncSale(data) {
  return Vue.axios({
    url: '/api/feishu/syncSale',
    method: 'post',
    data: { ...data }
  })
}

// 获取「客户维度 → 飞书」同步配置（含全局默认与可同步字段定义）
export function feishuCustomerSyncConfig(data) {
  return Vue.axios({
    url: '/api/feishu/customerSyncConfig',
    method: 'get',
    params: { ...data }
  })
}

// 保存「客户维度 → 飞书」全局同步配置
export function saveFeishuCustomerSyncConfig(data) {
  return Vue.axios({
    url: '/api/feishu/customerSyncConfig',
    method: 'post',
    data: { ...data }
  })
}

// 同步客户维度到飞书多维表格（可携带临时覆盖配置）
export function feishuSyncCustomer(data) {
  return Vue.axios({
    url: '/api/feishu/syncCustomer',
    method: 'post',
    data: { ...data }
  })
}

// 获取「红人维度 → 飞书」同步配置（含全局默认与可同步字段定义）
export function feishuArtistSyncConfig(data) {
  return Vue.axios({
    url: '/api/feishu/artistSyncConfig',
    method: 'get',
    params: { ...data }
  })
}

// 保存「红人维度 → 飞书」全局同步配置
export function saveFeishuArtistSyncConfig(data) {
  return Vue.axios({
    url: '/api/feishu/artistSyncConfig',
    method: 'post',
    data: { ...data }
  })
}

// 同步红人维度到飞书多维表格（可携带临时覆盖配置）
export function feishuSyncArtist(data) {
  return Vue.axios({
    url: '/api/feishu/syncArtist',
    method: 'post',
    data: { ...data }
  })
}

// 获取「广告主类型（订单来源）→ 飞书」同步配置（含全局默认与可同步字段定义）
export function feishuOrderSourceSyncConfig(data) {
  return Vue.axios({
    url: '/api/feishu/orderSourceSyncConfig',
    method: 'get',
    params: { ...data }
  })
}

// 保存「广告主类型（订单来源）→ 飞书」全局同步配置
export function saveFeishuOrderSourceSyncConfig(data) {
  return Vue.axios({
    url: '/api/feishu/orderSourceSyncConfig',
    method: 'post',
    data: { ...data }
  })
}

// 同步广告主类型（订单来源）到飞书多维表格（可携带临时覆盖配置）
export function feishuSyncOrderSource(data) {
  return Vue.axios({
    url: '/api/feishu/syncOrderSource',
    method: 'post',
    data: { ...data }
  })
}

// 获取「合作形式 → 飞书」同步配置（含全局默认与可同步字段定义）
export function feishuOrderWorkFormSyncConfig(data) {
  return Vue.axios({
    url: '/api/feishu/orderWorkFormSyncConfig',
    method: 'get',
    params: { ...data }
  })
}

// 保存「合作形式 → 飞书」全局同步配置
export function saveFeishuOrderWorkFormSyncConfig(data) {
  return Vue.axios({
    url: '/api/feishu/orderWorkFormSyncConfig',
    method: 'post',
    data: { ...data }
  })
}

// 同步合作形式到飞书多维表格（可携带临时覆盖配置）
export function feishuSyncOrderWorkForm(data) {
  return Vue.axios({
    url: '/api/feishu/syncOrderWorkForm',
    method: 'post',
    data: { ...data }
  })
}

// 获取「各平台单量（不包含冲账订单单量）→ 飞书」同步配置（含全局默认与可同步字段定义）
export function feishuPlatformCountSyncConfig(data) {
  return Vue.axios({
    url: '/api/feishu/platformCountSyncConfig',
    method: 'get',
    params: { ...data }
  })
}

// 保存「各平台单量（不包含冲账订单单量）→ 飞书」全局同步配置
export function saveFeishuPlatformCountSyncConfig(data) {
  return Vue.axios({
    url: '/api/feishu/platformCountSyncConfig',
    method: 'post',
    data: { ...data }
  })
}

// 同步各平台单量到飞书多维表格（可携带临时覆盖配置）
export function feishuSyncPlatformCount(data) {
  return Vue.axios({
    url: '/api/feishu/syncPlatformCount',
    method: 'post',
    data: { ...data }
  })
}

// 获取「平台金额（包含冲账订单金额）→ 飞书」同步配置（含全局默认与可同步字段定义）
export function feishuPlatformMoneySyncConfig(data) {
  return Vue.axios({
    url: '/api/feishu/platformMoneySyncConfig',
    method: 'get',
    params: { ...data }
  })
}

// 保存「平台金额（包含冲账订单金额）→ 飞书」全局同步配置
export function saveFeishuPlatformMoneySyncConfig(data) {
  return Vue.axios({
    url: '/api/feishu/platformMoneySyncConfig',
    method: 'post',
    data: { ...data }
  })
}

// 同步平台金额到飞书多维表格（可携带临时覆盖配置）
export function feishuSyncPlatformMoney(data) {
  return Vue.axios({
    url: '/api/feishu/syncPlatformMoney',
    method: 'post',
    data: { ...data }
  })
}

// 获取「AE执行月份维度 → 飞书」同步配置（含全局默认与可同步字段定义）
export function feishuExecutorAllMonthSyncConfig(data) {
  return Vue.axios({
    url: '/api/feishu/executorAllMonthSyncConfig',
    method: 'get',
    params: { ...data }
  })
}

// 保存「AE执行月份维度 → 飞书」全局同步配置
export function saveFeishuExecutorAllMonthSyncConfig(data) {
  return Vue.axios({
    url: '/api/feishu/executorAllMonthSyncConfig',
    method: 'post',
    data: { ...data }
  })
}

// 同步 AE执行月份维度 到飞书多维表格（可携带临时覆盖配置）
export function feishuSyncExecutorAllMonth(data) {
  return Vue.axios({
    url: '/api/feishu/syncExecutorAllMonth',
    method: 'post',
    data: { ...data }
  })
}

// 获取「AE执行人维度 → 飞书」同步配置（含全局默认与可同步字段定义）
export function feishuExecutorSyncConfig(data) {
  return Vue.axios({
    url: '/api/feishu/executorSyncConfig',
    method: 'get',
    params: { ...data }
  })
}

// 保存「AE执行人维度 → 飞书」全局同步配置
export function saveFeishuExecutorSyncConfig(data) {
  return Vue.axios({
    url: '/api/feishu/executorSyncConfig',
    method: 'post',
    data: { ...data }
  })
}

// 同步 AE执行人维度 到飞书多维表格（可携带临时覆盖配置）
export function feishuSyncExecutor(data) {
  return Vue.axios({
    url: '/api/feishu/syncExecutor',
    method: 'post',
    data: { ...data }
  })
}

// 获取「行业品牌合作维度 → 飞书」同步配置
export function feishuBrandTradeSyncConfig(data) {
  return Vue.axios({url: '/api/feishu/brandTradeSyncConfig', method: 'get', params: { ...data }})
}

// 保存「行业品牌合作维度 → 飞书」全局同步配置
export function saveFeishuBrandTradeSyncConfig(data) {
  return Vue.axios({url: '/api/feishu/brandTradeSyncConfig', method: 'post', data: { ...data }})
}

// 同步行业品牌合作维度到飞书多维表格
export function feishuSyncBrandTrade(data) {
  return Vue.axios({url: '/api/feishu/syncBrandTrade', method: 'post', data: { ...data }})
}

// 获取「品牌投放TOP100 → 飞书」同步配置
export function feishuBrandTopSyncConfig(data) {
  return Vue.axios({url: '/api/feishu/brandTopSyncConfig', method: 'get', params: { ...data }})
}

// 保存「品牌投放TOP100 → 飞书」全局同步配置
export function saveFeishuBrandTopSyncConfig(data) {
  return Vue.axios({url: '/api/feishu/brandTopSyncConfig', method: 'post', data: { ...data }})
}

// 同步品牌投放TOP100到飞书多维表格
export function feishuSyncBrandTop(data) {
  return Vue.axios({url: '/api/feishu/syncBrandTop', method: 'post', data: { ...data }})
}

// 获取「品类品牌合作维度 → 飞书」同步配置
export function feishuBrandCategorySyncConfig(data) {
  return Vue.axios({url: '/api/feishu/brandCategorySyncConfig', method: 'get', params: { ...data }})
}

// 保存「品类品牌合作维度 → 飞书」全局同步配置
export function saveFeishuBrandCategorySyncConfig(data) {
  return Vue.axios({url: '/api/feishu/brandCategorySyncConfig', method: 'post', data: { ...data }})
}

// 同步品类品牌合作维度到飞书多维表格
export function feishuSyncBrandCategory(data) {
  return Vue.axios({url: '/api/feishu/syncBrandCategory', method: 'post', data: { ...data }})
}

// 获取「品牌集团维度 → 飞书」同步配置
export function feishuBrandCombineSyncConfig(data) {
  return Vue.axios({url: '/api/feishu/brandCombineSyncConfig', method: 'get', params: { ...data }})
}

// 保存「品牌集团维度 → 飞书」全局同步配置
export function saveFeishuBrandCombineSyncConfig(data) {
  return Vue.axios({url: '/api/feishu/brandCombineSyncConfig', method: 'post', data: { ...data }})
}

// 同步品牌集团维度到飞书多维表格
export function feishuSyncBrandCombine(data) {
  return Vue.axios({url: '/api/feishu/syncBrandCombine', method: 'post', data: { ...data }})
}

// 获取「产地维度 → 飞书」同步配置
export function feishuPlaceOfOriginSyncConfig(data) {
  return Vue.axios({url: '/api/feishu/placeOfOriginSyncConfig', method: 'get', params: { ...data }})
}

// 保存「产地维度 → 飞书」全局同步配置
export function saveFeishuPlaceOfOriginSyncConfig(data) {
  return Vue.axios({url: '/api/feishu/placeOfOriginSyncConfig', method: 'post', data: { ...data }})
}

// 同步产地维度到飞书多维表格
export function feishuSyncPlaceOfOrigin(data) {
  return Vue.axios({url: '/api/feishu/syncPlaceOfOrigin', method: 'post', data: { ...data }})
}

// 获取「产品库统计（招商维度）→ 飞书」同步配置
export function feishuProductLibrarySyncConfig(data) {
  return Vue.axios({url: '/api/feishu/productLibrarySyncConfig', method: 'get', params: { ...data }})
}

// 保存「产品库统计（招商维度）→ 飞书」全局同步配置
export function saveFeishuProductLibrarySyncConfig(data) {
  return Vue.axios({url: '/api/feishu/productLibrarySyncConfig', method: 'post', data: { ...data }})
}

// 同步产品库统计（招商维度）到飞书多维表格
export function feishuSyncProductLibrary(data) {
  return Vue.axios({url: '/api/feishu/syncProductLibrary', method: 'post', data: { ...data }})
}

// 获取「视频号专区统计（招商维度）→ 飞书」同步配置
export function feishuVideoZoneSyncConfig(data) {
  return Vue.axios({url: '/api/feishu/videoZoneSyncConfig', method: 'get', params: { ...data }})
}

// 保存「视频号专区统计（招商维度）→ 飞书」全局同步配置
export function saveFeishuVideoZoneSyncConfig(data) {
  return Vue.axios({url: '/api/feishu/videoZoneSyncConfig', method: 'post', data: { ...data }})
}

// 同步视频号专区统计（招商维度）到飞书多维表格
export function feishuSyncVideoZone(data) {
  return Vue.axios({url: '/api/feishu/syncVideoZone', method: 'post', data: { ...data }})
}

// ===== 定时推送（表格管理 + 推送记录） =====
// 推送表格管理列表
export function feishuPushTables(data) {
  return Vue.axios({url: '/api/feishu/push/tables', method: 'get', params: { ...data }})
}

// 新增 / 编辑推送表格
export function saveFeishuPushTable(data) {
  return Vue.axios({url: '/api/feishu/push/tables', method: 'post', data: { ...data }})
}

// 删除推送表格
export function deleteFeishuPushTable(id) {
  return Vue.axios({url: `/api/feishu/push/tables/${id}`, method: 'delete'})
}

// 推送模块清单（表名 = tab-module）
export function feishuPushModules() {
  return Vue.axios({url: '/api/feishu/push/modules', method: 'get'})
}

// 某表格的推送记录列表
export function feishuPushRecords(data) {
  return Vue.axios({url: '/api/feishu/push/records', method: 'get', params: { ...data }})
}

// 手动触发推送（预留接口）
export function feishuPushTrigger(data) {
  return Vue.axios({url: '/api/feishu/push/trigger', method: 'post', data: { ...data }})
}
